/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';

import type { SubscriptionPlanStore } from './subscription-plan-store';

export const SubscriptionPlanContext = React.createContext<SubscriptionPlanStore>({} as SubscriptionPlanStore);
